import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37d4c78e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=37d4c78e&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=37d4c78e&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&id=37d4c78e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4c78e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d4c78e')) {
      api.createRecord('37d4c78e', component.options)
    } else {
      api.reload('37d4c78e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37d4c78e&scoped=true&", function () {
      api.rerender('37d4c78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/index.vue"
export default component.exports